/**
 * Shared helpers for the call log + overview: map a call's linked captured item
 * to a colored type pill, and format caller / property fields.
 */

// Captured-item type -> pill label + colors (keeps the app's navy for leads).
export const TYPE_META = {
  maintenance_request: { label: 'Maintenance', color: '#d46b08', bg: '#fff7e6' },
  owner_request: { label: 'Owner', color: '#389e0d', bg: '#f6ffed' },
  lead: { label: 'Leasing', color: '#1e3a5f', bg: '#e6f0ff' },
  tour: { label: 'Tour', color: '#531dab', bg: '#f9f0ff' },
  reservation: { label: 'Reservation', color: '#531dab', bg: '#f9f0ff' },
  order: { label: 'Order', color: '#531dab', bg: '#f9f0ff' },
  appointment: { label: 'Appointment', color: '#08979c', bg: '#e6fffb' },
  message: { label: 'Message', color: '#595959', bg: '#fafafa' },
  other: { label: 'Call', color: '#595959', bg: '#fafafa' }
};

export function cap(s) {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

export function formatPhone(v) {
  if (!v) return '—';
  const d = String(v).replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  return d.length === 10 ? `(${d.slice(0, 3)})${d.slice(3, 6)}-${d.slice(6)}` : v;
}

export function callerLabel(x) {
  const c = x?.contact;
  if (c?.name) return c.name;
  if (c?.phone) return formatPhone(c.phone);
  return x?.who || '';
}

export function toE164(v) {
  const raw = String(v || '').trim();
  const d = raw.replace(/\D/g, '');
  if (raw.startsWith('+') && d.length >= 10) return `+${d}`;
  if (d.length === 10) return `+1${d}`;
  if (d.length === 11 && d.startsWith('1')) return `+${d}`;
  return null;
}

const HVAC_RX = /\b(hvac|a\/?c|air ?condition\w*|(?<!water )heat(?:ing|er)?|furnace|thermostat|cooling)\b/i;

function isHvac(item) {
  const d = item?.data || {};
  return HVAC_RX.test([d.category, d.issue, item?.title].filter(Boolean).join(' '));
}

// Which filter bucket a call belongs to (used by the Call Log type pills).
export function bucketFor(item) {
  if (!item) return 'other';
  if (item.priority === 'emergency') return 'emergency';
  if (item.type === 'lead') return 'leasing';
  if (item.type === 'owner_request') return 'owner';
  if (item.type === 'maintenance_request') return isHvac(item) ? 'hvac' : 'maintenance';
  return 'other';
}

export function propertyFor(call, item) {
  const d = item?.data || {};
  return (
    d.propertyUnit ||
    [d.property || d.address, d.unit ? `Unit ${d.unit}` : null].filter(Boolean).join(', ') ||
    call?.metadata?.property ||
    '—'
  );
}
